<template>
    <div class="container">
      <h2>{{ $t('titre.logsinfo') }}</h2>
  
      <!-- Table with Column Filters -->
      <table class="table table-striped">
        <thead>
          <tr>
            <th>ID <input v-model="filters.id" class="filter-input" placeholder="Filter ID" /></th>
            <th>User <input v-model="filters.userId" class="filter-input" placeholder="Filter User" /></th>
            <th>Action <input v-model="filters.action" class="filter-input" placeholder="Filter Action" /></th>
            <th>Page <input v-model="filters.page" class="filter-input" placeholder="Filter Page" /></th>
            <th>Timestamp</th>
            <th>Details</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="log in paginatedLogs" :key="log.id">
            <td>{{ log.id }}</td>
            <td>{{ log.userId }}</td>
            <td>{{ log.action }}</td>
            <td>{{ log.page }}</td>
            <td>{{ formatDate(log.timestampBack) }}</td>
            <td>
              <button id="ignore" @click="showDetails(log)" class="btn btn-info btn-sm">View Details</button>
            </td>
          </tr>
        </tbody>
      </table>
  
      <!-- Pagination Controls -->
      <div class="pagination">
        <button id="ignore" @click="firstPage" :disabled="currentPage === 1">⏮ First</button>
        <button id="ignore" @click="prevPage" :disabled="currentPage === 1">❮</button>
        <span>{{ currentPage }} / {{ totalPages }}</span>
        <button id="ignore" @click="nextPage" :disabled="currentPage === totalPages">❯</button>
        <button id="ignore" @click="lastPage" :disabled="currentPage === totalPages">Last ⏭</button>
      </div>
  
      <!-- Details Modal -->
      <div v-if="selectedLog" class="modal" @click="selectedLog = null">
        <div class="modal-content" @click.stop>
          <h3>Log Details</h3>
          <p><strong>User:</strong> {{ selectedLog.userId }}</p>
          <p><strong>Action:</strong> {{ selectedLog.action }}</p>
          <p><strong>Page:</strong> {{ selectedLog.page }}</p>
          <p><strong>Timestamp:</strong> {{ formatDate(selectedLog.timestampBack) }}</p>
          <p><strong>Browser:</strong> {{ selectedLog.browser }}</p>
          <p><strong>Device:</strong> {{ selectedLog.device }}</p>
          <p><strong>Session:</strong> {{ selectedLog.sessionId }}</p>
          <button class="btn btn-danger" id="ignore" @click="selectedLog = null">Close</button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { TrackingService } from "../api";
  
  export default {
    data() {
      return {
        logs: [],
        filters: {
          id: "",
          userId: "",
          action: "",
          page: "",
        },
        selectedLog: null,
        currentPage: 1,
        pageSize: 10, // 10 logs per page
      };
    },
    computed: {
      filteredLogs() {
        return this.logs
          .filter((log) =>
            Object.keys(this.filters).every(
              (key) => !this.filters[key] || log[key].toString().toLowerCase().includes(this.filters[key].toLowerCase())
            )
          )
          .sort((a, b) => new Date(b.timestampBack) - new Date(a.timestampBack)); // Sort by timestamp DESC
      },
      totalPages() {
        return Math.ceil(this.filteredLogs.length / this.pageSize);
      },
      paginatedLogs() {
        const start = (this.currentPage - 1) * this.pageSize;
        const end = start + this.pageSize;
        return this.filteredLogs.slice(start, end);
      },
    },
    async created() {
      this.logs = await TrackingService.getLogs();
    },
    methods: {
      formatDate(timestamp) {
        return new Date(timestamp).toLocaleString();
      },
      showDetails(log) {
        this.selectedLog = log;
      },
      nextPage() {
        if (this.currentPage < this.totalPages) {
          this.currentPage++;
        }
      },
      prevPage() {
        if (this.currentPage > 1) {
          this.currentPage--;
        }
      },
      firstPage() {
        this.currentPage = 1;
      },
      lastPage() {
        this.currentPage = this.totalPages;
      },
    },
  };
  </script>
  
  <style scoped>
  .container {
    margin-top: 20px;
    border: 1px solid #ddd;
    padding: 0px;
    border-radius: 10px;
  }
  
  .filter-input {
    width: 100%;
    padding: 4px;
    font-size: 14px;
    margin-top: 5px;
    border: 1px solid #ddd;
    border-radius: 4px;
  }
  
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .modal-content {
    background: white;
    padding: 20px;
    border-radius: 5px;
  }
  
  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
  }
  
  .pagination button {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 5px 10px;
    margin: 0 5px;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .pagination button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
  
  .pagination span {
    font-size: 16px;
    font-weight: bold;
  }

  h2 {
    background-color: #47c399;
    border-radius: 10px 10px 0 0;
    color: azure;
    padding: 3px;
    text-align: justify;
    padding-left: 15px;
  }
  </style>
  